import { TextField, Select, MenuItem, Box } from '@mui/material';
import { useState } from 'react';
import logger from 'src/logger';

export const WeightInput = ({ value, onChange }) => {
  const [weight, setWeight] = useState('');
  const [unit, setUnit] = useState('lb');

  const handleWeightChange = (e) => {
    logger.debug('AddImage - ImageCard weight change received string:', e);
    logger.debug('AddImage - ImageCard weight change received string:', e.target.value);
    const newWeight = e.target.value;
    setWeight(newWeight);
    onChange(`${newWeight}${unit}`);
  };

  const handleUnitChange = (e) => {
    const newUnit = e.target.value;
    setUnit(newUnit);
    if (weight) {
      onChange(`${weight}${newUnit}`);
    }
  };

  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      <TextField
        type="number"
        size="small"
        label="Weight"
        value={weight}
        onChange={handleWeightChange}
        sx={{ flexGrow: 1 }}
      />
      <Select
        size="small"
        value={unit}
        onChange={handleUnitChange}
        sx={{ width: 80 }}
      >
        <MenuItem value="lb">lb</MenuItem>
        <MenuItem value="kg">kg</MenuItem>
      </Select>
    </Box>
  );
};